import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Suggested Engagement Actions by Owner',
      type: 'table',
      alias: 'suggested-engagement-actions-by-owner',
      content: {
        '{}': {
          count: 20,
          query: {
            '`': {
              sort: {
                by: {
                  '@.': '!name',
                },
              },
              target: 'ent:!stakeholders:!stakeholder',
              selection: {
                '{}': {
                  fields: {
                    '{}': {
                      suggestedOwner: {
                        '{}': {
                          value: 'Unassigned - confirm owner',
                        },
                      },
                      stakeholderName: {
                        '{}': {
                          value: {
                            '@.': '!name',
                          },
                        },
                      },
                      engagementAction: {
                        '{}': {
                          value: {
                            '@.': '!support_needs',
                          },
                        },
                      },
                      engagementNeeded: {
                        '{}': {
                          value: {
                            '@.': '!engagement_needed',
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
          columns: {
            '[]': [
              {
                '{}': {
                  id: 'suggestedOwner',
                  direct: {
                    '{}': {
                      name: 'Suggested Owner',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'stakeholderName',
                  direct: {
                    '{}': {
                      name: 'Stakeholder',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'engagementAction',
                  direct: {
                    '{}': {
                      name: 'Engagement / Support Action',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'engagementNeeded',
                  direct: {
                    '{}': {
                      name: 'Engagement Needed',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
            ],
          },
        },
      },
    },
  },
}
